import { MediaMatcher } from '@angular/cdk/layout';
import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

type StepDeclaration = {
  stepName: string;
  isStepClickable: boolean;
  stepTooltip?: string;
  stepTitle: string;
  stepHint?: string;
};
@Component({
  selector: 'orgbrain-progress-stepper',
  templateUrl: './progress-stepper.component.html',
  styleUrls: ['./progress-stepper.component.scss'],
  standalone: false,
})
export class ProgressStepperComponent implements OnInit {
  @Input() stepDeclarations: StepDeclaration[] = [];
  @Input() currentStep = '';
  @Output() stepClicked = new EventEmitter<StepDeclaration>();

  onClick(step: StepDeclaration) {
    if (step.isStepClickable) {
      this.stepClicked.emit(step);
    }
  }

  ngOnInit(): void {
    const firstStep = this.stepDeclarations.length > 0 ? this.stepDeclarations[0].stepName : '';

    this.currentStep = this.currentStep || firstStep;
  }

  public nextStep() {
    const currentIndex = this.stepDeclarations.findIndex(
      (step) => step.stepName === this.currentStep
    );
    if (currentIndex < this.stepDeclarations.length - 1) {
      this.currentStep = this.stepDeclarations[currentIndex + 1].stepName;
    }
  }

  get getCurrentStepIndex(): number {
    return this.stepDeclarations.findIndex((step) => step.stepName === this.currentStep);
  }

  get percentageCompleted(): number {
    const currentIndex = this.getCurrentStepIndex + 1;
    const numberOfSteps = this.stepDeclarations.length;

    if (currentIndex === numberOfSteps) return 100;

    return (currentIndex / (numberOfSteps + 1)) * 100;
  }

  isHighlightedStep(step: StepDeclaration) {
    const stepIndex = this.stepDeclarations.findIndex((s) => s.stepName === step.stepName);
    return stepIndex <= this.getCurrentStepIndex;
  }
}
